import { AgTechClickEventHandler } from "@agtech/web/components/Buttons/AgTechButtons";
import AgTechGridLink from "@agtech/web/components/Grids/Controls/AgTechGridLink";
import ContactInformationPopUp from "../../popups/ContactInformationPopUp";
import ContactDialog from "../../dialogs/ContactDialog";
import { AgTechPopUpCoreProps } from "@agtech/core/functions/AgTechAppPopUps";

export type ContactGridLinkProps = {
    contactName: string,
    contactId: number,
    classes?: string,
    onClick?: (e: AgTechClickEventHandler, contactId: number) => void,
    onHover?: (contactId: number) => AgTechPopUpCoreProps
}

export const ContactGridLink = (props: ContactGridLinkProps) => {
    return (
        <AgTechGridLink
            content={props.contactName}
            onClick={e => props.onClick ? props.onClick(e, props.contactId) : ContactLinkClick(e, props.contactId)}
            onHover={() => props.onHover ? props.onHover(props.contactId) : ContactLinkHover(props.contactId)}
            classes={props.classes}
        />
    )
}

export const ContactLinkClick = (e: AgTechClickEventHandler, contactId?: number) => {
    if (contactId) {
        e.dialogs.openDialog({
            dialog: () => <ContactDialog contactId={contactId} />
        });
    }
}

export const ContactLinkHover = (contactId: number): AgTechPopUpCoreProps => ({
    popup: () => <ContactInformationPopUp contactId={contactId} />,
    config: {
        topOffset: 24,
        shouldCloseOnBlur: false
    }
});